import script from "./TeacherInfos.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherInfos.vue?vue&type=script&setup=true&lang=js"

import "./TeacherInfos.vue?vue&type=style&index=0&id=83e4e566&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83e4e566"]])

export default __exports__